

.page {
  width: 100vw;
  height: 100vh;
  padding: 1rem;
}

.form {
  width: min(50rem, 50vw);
  margin-top: 10%;
}

.backButton {
  width: min-content;
  align-self: flex-start;
}

.logo {
  color: var(--color-primary);
  margin-bottom: 2rem;
}

.invalid {
  color: var(--sentiment-text-negative);
}